module.exports = __webpack_public_path__ + "static/media/lightning-shield.85367254.svg";